import React from "react";
import InputField from "./../../common/form/InputField";
import { useContext } from "react";
import { AppContext } from "../../../context/AppContext";
const OtherInfo = () => {
  const { selectedCountry } = useContext(AppContext);
  return (
    <>
      {selectedCountry === "187" ? (
        <div className="mt-5">
          <h1 className="text-md font-semibold ">OTHER INFO</h1>
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-2">
              <InputField
                type="text"
                label="Magazine Shipping Address"
                name="MagazineShippingAddress"
              />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default OtherInfo;
